import { FormDialog } from 'components/dialog/form'

import { SearchResult, SearchStatus, useEditSearchStatus } from 'interface/search'
import { useSearchStatusForm, SearchStatusForm } from '../form/searchStatusForm'

type StartAnalyticsDialogProps = {
	search: SearchResult
	onSubmit: (result: SearchResult) => void
	onClose: () => void
}
export const StartAnalyticsDialog = ({
  search,
  onSubmit,
  onClose
}: StartAnalyticsDialogProps) => {
  const form = useSearchStatusForm(search)
	const {
		form: {
			formState: { isValid },
			handleSubmit
		}
	} = form
	const [postState, submit] = useEditSearchStatus(search.searchId, { onEditted: onSubmit })

	return (
		<FormDialog
			open
			fullWidth
			maxWidth="xs"
			title={search.status === SearchStatus.Stop ? "分析開始" : "再分析"}
			isLoading={postState.posting}
			error={postState.error}
			body={<SearchStatusForm {...form}/>}
			submitLabel={search.status === SearchStatus.Stop ? "開始" : "再開"}
			isValid={isValid}
			onSubmit={handleSubmit((taskStatus) => submit({
				status: SearchStatus.InProgress,
				taskStatus
			}))}
			onClose={onClose}
		/>
	)
}